import {getBaseURL} from "../../../utils/env";

export default class LoginInfoRepository {
  constructor(api) {
    this.api = api
  }

  async loginUserStatus() {
    const url = `${getBaseURL()}users/login-info`
    return this.api.get(url)
  }
}
